import { Dropdown, DropdownButton } from 'react-bootstrap';
import React, { useState } from 'react';

import { Edit } from 'react-feather';
import ModalPhoneList from '../Modal/ModalPhoneList';
import { useTranslation } from 'react-i18next';

function DropdownEditPhone({ deviceId, listPhone, name, index }) {
  const [type, setType] = useState();
  const [show, setShow] = useState(false);
  const { t } = useTranslation();

  const handleShowEdit = () => {
    setType('edit');
    setShow(true);
  };

  const handleShowDelete = () => {
    setType('delete');
    setShow(true);
  };
  return (
    <>
      <DropdownButton
        size="sm"
        key="end"
        id="dropdown-button-drop-end"
        drop="end"
        variant="success"
        title={<Edit />}
      >
        <Dropdown.Item onClick={handleShowEdit}>{t('edit')}</Dropdown.Item>
        <Dropdown.Item onClick={handleShowDelete}>{t('delete')}</Dropdown.Item>
      </DropdownButton>
      <ModalPhoneList
        index={index}
        type={type}
        name={name}
        show={show}
        setShow={setShow}
        deviceId={deviceId}
        listPhone={listPhone}
      />
    </>
  );
}

export default DropdownEditPhone;
